import { Link, router } from '@inertiajs/react';
import AppLayout from '@/Layouts/AppLayout';
import PageHeader from '@/Components/PageHeader';
import Avatar from '@/Components/Avatar';
import Badge from '@/Components/Badge';
import Timeline from '@/Components/Timeline';
import Tabs from '@/Components/Tabs';

export default function ClientsShow({ client, sources }) {
    const timelineItems = [
        { id: 1, type: 'created', content: 'Client record created', user: client.created_by?.name || 'System', time: new Date(client.created_at).toLocaleString() },
        { id: 2, type: 'updated', content: 'Profile information updated', user: 'Admin', time: '2 days ago' },
    ];

    const tabs = [
        {
            id: 'overview',
            label: 'Overview',
            icon: 'bi-person',
            content: (
                <div className="row g-4">
                    <div className="col-md-6">
                        <div className="card h-100">
                            <div className="card-header"><h6 className="mb-0">Contact Information</h6></div>
                            <div className="card-body">
                                <dl className="row mb-0">
                                    <dt className="col-sm-4 text-muted">Email</dt>
                                    <dd className="col-sm-8">{client.email || '-'}</dd>
                                    <dt className="col-sm-4 text-muted">Phone</dt>
                                    <dd className="col-sm-8">{client.phone || '-'}</dd>
                                    <dt className="col-sm-4 text-muted">Alt. Phone</dt>
                                    <dd className="col-sm-8">{client.phone_alt || '-'}</dd>
                                    <dt className="col-sm-4 text-muted">Company</dt>
                                    <dd className="col-sm-8">{client.company || '-'}</dd>
                                    <dt className="col-sm-4 text-muted">Designation</dt>
                                    <dd className="col-sm-8">{client.designation || '-'}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card h-100">
                            <div className="card-header"><h6 className="mb-0">Address</h6></div>
                            <div className="card-body">
                                <dl className="row mb-0">
                                    <dt className="col-sm-4 text-muted">Country</dt>
                                    <dd className="col-sm-8">{client.country?.name || '-'}</dd>
                                    <dt className="col-sm-4 text-muted">State</dt>
                                    <dd className="col-sm-8">{client.state || '-'}</dd>
                                    <dt className="col-sm-4 text-muted">City</dt>
                                    <dd className="col-sm-8">{client.city || '-'}</dd>
                                    <dt className="col-sm-4 text-muted">ZIP</dt>
                                    <dd className="col-sm-8">{client.zip || '-'}</dd>
                                    <dt className="col-sm-4 text-muted">Address</dt>
                                    <dd className="col-sm-8">{client.address || '-'}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            ),
        },
        {
            id: 'activity',
            label: 'Activity',
            icon: 'bi-clock-history',
            content: <Timeline items={timelineItems} />,
        },
        {
            id: 'notes',
            label: 'Notes',
            icon: 'bi-sticky',
            content: (
                <div className="card">
                    <div className="card-body">
                        <p className="mb-0">{client.notes || 'No notes available.'}</p>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <AppLayout title={client.name}>
            <PageHeader
                title={client.name}
                subtitle={client.company || 'Individual Client'}
                breadcrumbs={[
                    { label: 'CRM' },
                    { label: 'Clients', href: '/clients' },
                    { label: client.name },
                ]}
                actions={
                    <div className="d-flex gap-2">
                        <Link href={`/clients/${client.id}/edit`} className="btn btn-outline-primary">
                            <i className="bi bi-pencil me-1"></i> Edit
                        </Link>
                        <button
                            className="btn btn-outline-secondary"
                            onClick={() => router.patch(`/clients/${client.id}/toggle-status`)}
                        >
                            <i className={`bi ${client.is_active ? 'bi-toggle-off' : 'bi-toggle-on'} me-1`}></i>
                            {client.is_active ? 'Deactivate' : 'Activate'}
                        </button>
                    </div>
                }
            />

            <div className="row">
                <div className="col-lg-4 mb-4">
                    <div className="card">
                        <div className="card-body text-center py-4">
                            <Avatar name={client.name} size="xl" className="mb-3" />
                            <h4 className="mb-1">{client.name}</h4>
                            {client.company && <p className="text-muted mb-2">{client.company}</p>}
                            <Badge variant={client.is_active ? 'success-subtle' : 'secondary'}>
                                {client.is_active ? 'Active' : 'Inactive'}
                            </Badge>
                        </div>
                        <hr className="my-0" />
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">Source</span>
                                <span>{sources[client.source] || '-'}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">Assigned To</span>
                                <span>{client.assigned_to?.name || '-'}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">DOB</span>
                                <span>{client.dob ? new Date(client.dob).toLocaleDateString() : '-'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="text-muted">Anniversary</span>
                                <span>{client.anniversary ? new Date(client.anniversary).toLocaleDateString() : '-'}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-8">
                    <Tabs tabs={tabs} variant="underline" />
                </div>
            </div>
        </AppLayout>
    );
}
